import React from 'react';
import PropTypes from 'prop-types';

import Button from '@decisiv/ui-components/lib/components/Button';
import { H2, P } from '@decisiv/ui-components/lib/components/Typography';
import UserPlus from '@decisiv/iconix/lib/components/UserPlus';
import UserTimes from '@decisiv/iconix/lib/components/UserTimes';

import roleTag from '../../../shared/roleTag';
import { TagRow } from '../../../shared/styles';
import {
  AccountRow,
  AccountRowActions,
  AccountRowHeader,
  AccountRowTitle,
  AccountsList,
  AccountsSectionHeader,
} from './styles';

function AccountAccessTable({
  canActOn,
  canEdit,
  accounts,
  onAdd,
  onRemove,
  onRestore,
}) {
  return (
    <section>
      <AccountsSectionHeader>
        <H2 style={{ margin: 0 }}>Accounts</H2>
        <P shade={1}>Manage the accounts associated with this user.</P>
      </AccountsSectionHeader>

      <AccountsList>
        {accounts.map((row) => {
          const isRemoved = Boolean(row.removedAt);

          return (
            <AccountRow key={row.id}>
              <AccountRowHeader>
                <AccountRowTitle>
                  <P weight="semibold">{row.name}</P>
                  <TagRow>
                    {row.roles.map((role) => (
                      <React.Fragment key={role}>
                        {roleTag(role)}
                      </React.Fragment>
                    ))}
                  </TagRow>
                </AccountRowTitle>

                {canEdit && (
                  <AccountRowActions>
                    <Button
                      disabled={!isRemoved && !canActOn(row)}
                      icon={isRemoved ? UserPlus : UserTimes}
                      kind="secondary"
                      onClick={() =>
                        isRemoved ? onRestore(row) : onRemove(row)
                      }
                      text={isRemoved ? 'Restore Access' : 'Remove Access'}
                    />
                  </AccountRowActions>
                )}
              </AccountRowHeader>

              <P shade={1} size="small">
                Account ID: {row.decisivId} &middot; Account Type:{' '}
                {row.dealerType}
              </P>
            </AccountRow>
          );
        })}
      </AccountsList>

      {canEdit && (
        <Button
          kind="secondary"
          style={{ marginTop: '1rem' }}
          text="Add To Account"
          onClick={onAdd}
        />
      )}
    </section>
  );
}

AccountAccessTable.propTypes = {
  canActOn: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      decisivId: PropTypes.string,
      name: PropTypes.string,
      dealerType: PropTypes.string,
      roles: PropTypes.arrayOf(PropTypes.string),
      removedAt: PropTypes.string,
    }),
  ),
};

AccountAccessTable.defaultProps = {
  canEdit: false,
  onAdd: () => {},
  accounts: [],
};

export default AccountAccessTable;
